//import angular from 'angular';
const moduleName = 'app.directives';
export default moduleName;

angular.module(moduleName, ['hmTouchEvents']);

    // directives moved to /app/directives/<directiveName>.js  
